export const contactInfo = {
  brandName: 'Pearl clean',
  city: 'Одеса',
  serviceArea: 'Одеса та околиці',
  displayLocation: 'Одеса, Україна',
  phone: '+380686906906',
  responseHours: '24/7'
};

export default contactInfo;
